import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { ActionListInput } from '@trackback/widgets';
import { AsyncPipe } from '@angular/common';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'tb-action-list',
  imports: [DynamicWidgetDirective, MatListModule, AsyncPipe, ParsePipe],
  template: `
    <mat-action-list
      [class]="input.styleClasses | parse: context | async"
      [disabled]="input.disabled | parse: context | async"
    >
      @for (child of input.children; track $index) {
        <ng-container [dynamicWidget]="child" [context]="context" />
      }
    </mat-action-list>
  `,
  styles: `
    tb-action-list {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class ActionListComponent {
  @Input()
  input: ActionListInput;

  @Input()
  context: Record<string, never>;
}
